import { render, staticRenderFns } from "./partner-information.vue?vue&type=template&id=fefc5522&scoped=true&"
import script from "./partner-information.vue?vue&type=script&lang=js&"
export * from "./partner-information.vue?vue&type=script&lang=js&"
import style0 from "./partner-information.vue?vue&type=style&index=0&id=fefc5522&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fefc5522",
  null
  
)

export default component.exports